import React, { useState, useRef, useEffect } from 'react';
import { Col, Container, Row, Toast } from 'react-bootstrap';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

//  Styles
import './Clients.scss';

//  Some assets
import developmentImg from '../../../images/JavaScript frameworks-pana.svg';

// Clients
import clients from '../../../data/clientElements';

// CV
import CV from '../../../assets/CV-EN.pdf';


const Clients = () => {
	gsap.registerPlugin(ScrollTrigger);
	//  My CV
	const cv = {
		file: CV,
		filename: 'CV-Francisco-Silva.pdf',
    };
    
	const [show, setShow] = useState(false);

	//  Props references
	const clientsRef = useRef([]);
	const infoRef = useRef(null);
	clientsRef.current = [];
	infoRef.current = null;

	const calcDelay = index => {
		if (index === 0) {
			return index;
		}
		return index - index * 0.6;
	};

	useEffect(() => {
		gsap.fromTo(
			infoRef.current,
			{ autoAlpha: 0, y: 50 },
			{
				duration: 1,
				autoAlpha: 1,
				y: 0,
				ease: 'power4.out',
				scrollTrigger: {
					id: 'clientes__grelha',
					trigger: infoRef.current,
					start: 'top center+=100',
				},
			}
		);

		clientsRef.current.forEach((el, index) => {
			gsap.fromTo(
				el,
				{ autoAlpha: 0, y: 50 },
				{
					duration: 1,
					autoAlpha: 1,
					y: 0,
					delay: calcDelay(index),
					ease: 'power4.out',
					scrollTrigger: {
						id: `clientes__grelha`,
						trigger: el,
						start: 'top center+=100',
					},
				}
			);
		});
	}, []);

	const addToRefs = el => {
		if (el && !clientsRef.current.includes(el)) {
			clientsRef.current.push(el);
		}
	};

	return (
		<div id="clientes" className="block-alt">
			<Container>
				<Toast onClose={() => setShow(false)} show={show} delay={3000}>
					<Toast.Header>
						<strong className="me-auto">Francisco Silva</strong>
						<small>Now</small>
					</Toast.Header>
					<Toast.Body>
						Thanks for downloading my CV, if you have any in doubt,
						reach me <a href="contacto">here</a>.
					</Toast.Body>
				</Toast>
				<Row>
					<Col className="align-self-center " id="clientes__grelha">
						<Row>
							<h3 ref={addToRefs}>Some clients 💼</h3>
							{clients.map(client => {
								return (
									<Col
										key={client.id}
										ref={addToRefs}
										sm={6}
										md={4}>
										<a
											href={client.link}
											target="_blank"
											rel="noopener noreferrer"
											className="link-cliente">
											<img
												src={client.img}
												alt={`${client.name} Logo`}
												className="img-fluid"
											/>
										</a>
									</Col>
								);
							})}
						</Row>
					</Col>
					<Col className="align-self-center">
						<div className="cliente-text ml-5" ref={infoRef}>
							<Row className="imagem">
								<Col sm={12} lg={6}>
									<img
										src={developmentImg}
										alt="Web Development Asset"
										className="img-fluid"
									/>
								</Col>
								<Col sm={12} lg={6}>
									<div className="pl-md-0 pl-3 text-white">
										<span>3</span> years developing
										<a
											className="btn btn-light btn-sm my-4"
											href={cv.file}
											download={cv.filename}
											onClick={() => setShow(true)}>
											<i className="fas fa-download me-1"></i>{' '}
											Curriculum Vitae
										</a>
									</div>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default Clients;
